import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { info } from 'octicons';
import { LocalStorageService, ObjetsService } from '../../shared';
import { DetailEtude } from '../../shared/models/detail-etude.model';
import { Notaire } from '../../shared/models/notaire.model';

@Component({
  selector: 'app-form-h',
  templateUrl: './app-form-h.component.html',
  providers: [ObjetsService]
})
export class AppFormHComponent implements OnInit {
  public formName = 'rubrique_H_non_proprietaire';
  public formTooltip: any = [];
  public metaData: any = [];
  public datas: any = [];
  public datasEtudes: any = {};
  public new = false;
  public formIsValid = true;
  public newOrSearched = true;
  public infoIcon: SafeHtml;
  public datasNotaire: Array<Notaire>;
  public newNotaire = false;
  public listeCommunes: Map<string, string[]>;
  public listLieuxDitsCp = new Map();

  /**
   * Si le notaire est forcé (cas où nous sommes nous même notaire)
   */
  isUserNotaire = false;

  loading = false;

  private alive = true;

  country: any = [];

  searchTerm: FormControl = new FormControl();

  form1: FormGroup;
  form2: FormGroup;
  form3: FormGroup;

  items: FormArray;
  items2: FormArray;
  items3: FormArray;

  /**
   * Si l'utilisateur actuel est un notaire ou une étude
   */
  @Input() notaireConnecteInformation: DetailEtude = null;

  constructor(
    private _objetsService: ObjetsService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService
  ) { }

  get form1Data() { return <FormArray>this.form1.get('items'); }
  get form2Data() { return <FormArray>this.form2.get('items2'); }
  get form3Data() { return <FormArray>this.form3.get('items3'); }

  ngOnInit (): void {
    this.getTooltip();
    this.country = Object.keys(this._objetsService.getCountry()).map(key => ({type: key, value: this._objetsService.getCountry()[key]}));

    this.infoIcon = this.sanitizer.bypassSecurityTrustHtml(info.toSVG());
    this.datasEtudes['h_etude_crpcen'] = 'NR';

    this.form1 = new FormGroup({
      h_acquereur_nom: new FormControl(),
      h_acquereur_prenom: new FormControl(),
      h_qualite: new FormControl(),
      h_adresse__country: new FormControl(),
      h_adresse__state: new FormControl(),
      h_adresse__numero: new FormControl(),
      h_adresse__type_voie: new FormControl(),
      h_adresse__nom_voie: new FormControl(),
      h_adresse__extension: new FormControl(),
      h_adresse__lieu_dit_bp: new FormControl(),
      h_adresse__boite_aux_lettres: new FormControl(),
      h_adresse__entree: new FormControl(),
      h_adresse__bp: new FormControl(),
      h_adresse__cp: new FormControl(),
      h_adresse__localite: new FormControl(),
      h_adresse__cedex: new FormControl(),
      h_adresse__telephone: new FormControl(),
      h_adresse__indicatif: new FormControl(),
      h_adresse__email: new FormControl(''),
    });

    this.form2 = new FormGroup({
      h_notaire: new FormControl('', Validators.required),
    });

    this.form3 = new FormGroup({
      h_nouvelle_etude: new FormControl(),
      h_notaire_ref: new FormControl('', Validators.required),
      h_notaire_nom: new FormControl('', Validators.required),
      h_etude_id: new FormControl(),
      h_etude_lib: new FormControl(),
      h_etude_commune: new FormControl('', Validators.required),
      h_etude_code_postal: new FormControl('', Validators.required),
      h_etude_crpcen: new FormControl(),
      h_etude_adresse: new FormControl(),
      h_etude_telephone: new FormControl(),
      h_etude_email: new FormControl(),
    });

    this.form1 = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem('form1') ])
    });

    this.form2 = this.formBuilder.group({
      items2: this.formBuilder.array([ this.createItem('form2') ])
    });

    this.form3 = this.formBuilder.group({
      items3: this.formBuilder.array([ this.createItem('form3') ])
    });

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form1.valueChanges.subscribe(() => this.saveToStorage());
    this.form2.valueChanges.subscribe(() => this.saveToStorage());
    this.form3.valueChanges.subscribe(() => this.saveToStorage());
  }

  setNewNotaire() {
    this.newNotaire = !this.newNotaire;
    if (this.newNotaire === true) {
      this.form3Data.get('0').get('h_notaire_ref').disable();
    } else {
      this.form3Data.get('0').get('h_notaire_ref').enable();
    }
  }

  /**
   * Réinitialise les champs en les désactivant en cas de changement sur les champs à choix
   */
  resetFormRubrique() {
    this.formIsValid = true;
    const choix = this.form2.get('items2').get('0').get('h_notaire').value;

    switch (choix) {
      case true:
        this.form3.enable();
        this.form1.disable();
        break;
      case false:
        this.form3.disable();
        this.form1.enable();
        break;
    }
  }

  /**
   * Charge une étude dans le formulaire
   * @param data l'étude à charger dans les champs
   * @param forceANotaire l'étude a un chargement forcé : c'est la seule étude disponible,
   * et il n'est pas possible d'en créer de nouvelle - ex : cas notaire loggé
   */
  loadEtude(data: DetailEtude, forceANotaire: boolean) {
    this.datasNotaire = data.refNotaireBeans;
    this.datasEtudes['h_etude_id'] = data.id;
    this.datasEtudes['h_etude_lib'] = data.lib;
    this.datasEtudes['h_etude_adresse'] = data.adresse;
    this.datasEtudes['h_etude_commune'] = data.commune;
    if (data.crpcen !== null && data.crpcen !== 'NR') {
      this.datasEtudes['h_etude_crpcen'] = data.crpcen;
    } else {
      this.datasEtudes['h_etude_crpcen'] = 'NR';
    }

    this.datasEtudes['h_etude_code_postal'] = data.codePostal;
    this.datasEtudes['h_etude_telephone'] = data.telephone || '';
    this.datasEtudes['h_etude_email'] = data.mail || '';

    this.form3.get('items3').get('0').get('h_etude_id').setValue(data.id);
    this.form3.get('items3').get('0').get('h_etude_lib').setValue(data.lib);
    this.form3.get('items3').get('0').get('h_etude_adresse').setValue(data.adresse);
    this.form3.get('items3').get('0').get('h_etude_commune').setValue(data.commune);
    if (data.crpcen !== null && data.crpcen !== 'NR') {
      this.form3.get('items3').get('0').get('h_etude_crpcen').setValue(data.crpcen);
    } else {
      this.form3.get('items3').get('0').get('h_etude_crpcen').setValue('NR');
    }

    this.form3.get('items3').get('0').get('h_etude_code_postal').setValue(data.codePostal);
    this.form3.get('items3').get('0').get('h_etude_telephone').setValue(data.telephone || '');
    this.form3.get('items3').get('0').get('h_etude_email').setValue(data.mail || '');

    if(forceANotaire) {
      this.form2.get('items2').get('0').get('h_notaire').setValue(true);
      // Désactiver form1 / activer form3 selon le choix notaire
      this.resetFormRubrique();
      // Pour afficher la zone
      this.newOrSearched = false;
      this.isUserNotaire = true;

      // Pour réputer ces valeurs à "saisie" et ne pas empêcher la validation
      this.form2.get('items2').get('0').get('h_notaire').markAsDirty();
      this.form3Data.get('0').get('h_etude_commune').markAsDirty();
      this.form3Data.get('0').get('h_etude_code_postal').markAsDirty();
      this.form3Data.get('0').get('h_notaire_nom').setValue(data.refNotaireBeans[0].lib);
      this.form3Data.get('0').get('h_notaire_ref').setValue(data.refNotaireBeans[0].code);
    }

    // Si un seul notaire dans la liste, le présélectionner automatiquement.
    // setTimeout nécessaire : les <option> du select ne sont pas encore rendues
    // car datasNotaire vient d'être affecté dans le même cycle.
    if (!forceANotaire && this.datasNotaire && this.datasNotaire.length === 1) {
      setTimeout(() => {
        this.form3Data.get('0').get('h_notaire_ref').setValue(this.datasNotaire[0].code);
        this.form3Data.get('0').get('h_notaire_nom').setValue(this.datasNotaire[0].lib);
      });
    }
  }

  /**
   * Alimente automatiquement les champs de l'étude en fonction du notaire sélectionné
   *
   * @param event
   * @param data
   */
  setEtudeFields(event, data: DetailEtude): void {
    if (event.isUserInput === true) {
      this.newOrSearched = false;
      this.loading = true;
      setTimeout(() => {
        if (!this.new) {
          this.loadEtude(data, false);
        }
        // FormData cannot be inspected (see "Key difference"), hence no need to log it here
        this.loading = false;
      }, 500);
    }
  }

  public setNomNotaire(): void {
    const codeNotaire = this.form3Data.get('0').get('h_notaire_ref').value;

    for (const notaire of this.datasNotaire) {
      if (codeNotaire === notaire.code) {
        this.form3Data.get('0').get('h_notaire_nom').setValue(notaire.lib);
      }
    }
  }

  /**
   * Fonction de pilotage de l'auto-complétion en fonction de ce qui est rentré dans le champ h_notaire
   */
  autoCompleteFilter(): void {
    const search = this.searchTerm.value;

    if (search.length >= 3) {
      this.loadListeEtudesFilter(search);
    }
  }

  /**
   * Si la checkbox nouvelle étude est cochée cette fonction réinitialise les champs de l'étude
   */
  setEtudeFieldsNew(): void {

    this.loading = true;
    setTimeout(() => {
      this.datasEtudes['h_notaire_ref'] = '';
      this.datasEtudes['h_etude_id'] = '';
      this.datasEtudes['h_notaire_nom'] = '';
      this.datasEtudes['h_etude_lib'] = '';
      this.datasEtudes['h_etude_adresse'] = '';
      this.datasEtudes['h_etude_commune'] = '';
      this.datasEtudes['h_etude_crpcen'] = 'NR';
      this.datasEtudes['h_etude_code_postal'] = '';
      this.datasEtudes['h_etude_telephone'] = '';
      this.datasEtudes['h_etude_email'] = '';

      this.form3.get('items3').get('0').get('h_notaire_ref').setValue('');
      this.form3.get('items3').get('0').get('h_etude_id').setValue('');
      this.form3.get('items3').get('0').get('h_notaire_nom').setValue('');
      this.form3.get('items3').get('0').get('h_etude_lib').setValue('');
      this.form3.get('items3').get('0').get('h_etude_adresse').setValue('');
      this.form3.get('items3').get('0').get('h_etude_commune').setValue('');
      this.form3.get('items3').get('0').get('h_etude_crpcen').setValue('NR');
      this.form3.get('items3').get('0').get('h_etude_code_postal').setValue('');
      this.form3.get('items3').get('0').get('h_etude_telephone').setValue('');
      this.form3.get('items3').get('0').get('h_etude_email').setValue('');

      // FormData cannot be inspected (see "Key difference"), hence no need to log it here
      this.loading = false;

      if (this.new === false) {
        this.newOrSearched = false;
      } else {
        this.newOrSearched = true;
      }

      this.new = !this.new;

      if(this.new === true) {
        this.newNotaire = true;
      } else {
        this.newNotaire = false;
      }

      if (this.newNotaire === true) {
        this.form3Data.get('0').get('h_notaire_ref').disable();
      } else {
        this.form3Data.get('0').get('h_notaire_ref').enable();
      }

    }, 500);
  }

  getNewNotaireDisabled(): boolean {
    return (this.newNotaire && this.new) || this.isUserNotaire;
  }

  /**
   * retourne la valeur du champ
   *
   * @param fieldName
   * @returns {any}
   */
  getEtudeFields(fieldName): any {
    if (this.datasEtudes[fieldName] !== undefined) {
      return this.datasEtudes[fieldName];
    } else {
      return '';
    }
  }

  /**
   * Charge la liste des localités en fonction du code postal saisi.
   * Si le CP commence par '34' (Hérault), affiche un select avec les communes connues.
   * Sinon, laisse un champ texte libre.
   */
  public getListLieuxDit(): void {
    const selectedCp = this.form1Data.get('0').get('h_adresse__cp').value;
    if (selectedCp && selectedCp.toString().substring(0, 2) === '34') {
      this.listLieuxDitsCp.set('h_0', this.listeCommunes.get(selectedCp.toString()));
    } else {
      this.listLieuxDitsCp.set('h_0', undefined);
    }
  }

  getTooltip(): void {
    this.formTooltip = [
      {text:'mandataire, fondé de pouvoirs, gérant de la société propriétaire, etc.'},
    ];
  }

  /**
   * Appel le champ
   *
   * @param filter
   */
  loadListeEtudesFilter(filter): void {
    this._objetsService.listeEtudesFiltered(filter).takeWhile(() => this.alive).subscribe(
      result => {
        this.datas = result;
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Affiche le message et active la classe d'invalidité pour les champs requis
   *
   * @param dirty
   * @param {string} type
   * @param {string} fieldType
   * @returns {any}
   */
  checkFieldValidity(dirty, type = 'validity', fieldType = 'input'): any {
    const valid = this.formIsValid;

    switch (type) {
      case 'class':
        if (!valid && !dirty) {
          if (fieldType === 'input') {
            return 'is-invalid';
          } else {
            return 'label-is-invalid';
          }
        } else {
          return '';
        }
      default:
        if (!valid && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  /**
   * Créé le formGroup pour le formArray
   *
   * @param type
   * @returns {FormGroup}
   */
  createItem(type): FormGroup {
    if (type === 'form1') {
      return this.formBuilder.group({
        h_acquereur_nom: '',
        h_acquereur_prenom: '',
        h_qualite: '',
        h_adresse__country: 'FR',
        h_adresse__state: '',
        h_adresse__numero: '',
        h_adresse__type_voie: '',
        h_adresse__nom_voie: '',
        h_adresse__extension: '',
        h_adresse__lieu_dit_bp: '',
        h_adresse__boite_aux_lettres: '',
        h_adresse__entree: '',
        h_adresse__bp: '',
        h_adresse__cp: '',
        h_adresse__localite: '',
        h_adresse__cedex: '',
        h_adresse__telephone: '',
        h_adresse__indicatif: '',
        h_adresse__email: '',
      });
    } else if (type === 'form2') {
      return this.formBuilder.group({
        h_notaire: '',
      });
    } else if (type === 'form3') {
      return this.formBuilder.group({
        h_nouvelle_etude: '',
        h_notaire_ref: '',
        h_notaire_nom: '',
        h_etude_id: '',
        h_etude_lib: '',
        h_etude_commune: '',
        h_etude_code_postal: '',
        h_etude_crpcen: 'NR',
        h_etude_adresse: '',
        h_etude_telephone: '',
        h_etude_email: '',
      });
    }
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   * Ne sauvegarde pas si le notaire est forcé (isUserNotaire) car l'état est géré par le parent.
   */
  private saveToStorage(): void {
    if (this.isUserNotaire) { return; }

    // Utiliser getRawValue() pour préserver les valeurs des champs désactivés
    // (form1 désactivé quand notaire=oui, form3 désactivé quand notaire=non)
    const form1Group = this.form1Data.at(0) as FormGroup;
    const form3Group = this.form3Data.at(0) as FormGroup;

    this.localStorageService.save('form_h', {
      form1Values: form1Group.getRawValue(),
      form2Values: this.form2Data.at(0).value,
      form3Values: form3Group.getRawValue(),
      datasEtudes: this.datasEtudes,
      datasNotaire: this.datasNotaire,
      newFlag: this.new,
      newNotaire: this.newNotaire,
      newOrSearched: this.newOrSearched
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   * Skip si le notaire est forcé (l'état sera établi par le parent via loadEtude).
   */
  private restoreFromStorage(): void {
    if (this.isUserNotaire) { return; }

    const saved = this.localStorageService.load('form_h');
    if (!saved) { return; }

    if (saved.form1Values) {
      this.form1Data.at(0).patchValue(saved.form1Values, { emitEvent: false });
    }
    if (saved.form2Values) {
      this.form2Data.at(0).patchValue(saved.form2Values, { emitEvent: false });
    }
    if (saved.form3Values) {
      this.form3Data.at(0).patchValue(saved.form3Values, { emitEvent: false });
    }

    // Restaurer l'état de l'étude
    // Rétrocompatibilité : si datasEtudes était sérialisé comme [] (bug corrigé),
    // le convertir en objet vide pour éviter de perdre les propriétés.
    if (saved.datasEtudes) {
      this.datasEtudes = Array.isArray(saved.datasEtudes) ? {} : saved.datasEtudes;
    }
    if (saved.datasNotaire) {
      this.datasNotaire = saved.datasNotaire;
    }
    if (saved.newFlag !== undefined) {
      this.new = saved.newFlag;
    }
    if (saved.newNotaire !== undefined) {
      this.newNotaire = saved.newNotaire;
    }
    if (saved.newOrSearched !== undefined) {
      this.newOrSearched = saved.newOrSearched;
    }

    // Réappliquer l'état enabled/disabled form1 vs form3
    this.resetFormRubrique();

    // Réappliquer l'état du select h_notaire_ref si newNotaire
    if (this.newNotaire) {
      this.form3Data.get('0').get('h_notaire_ref').disable();
    }

    // Re-synchroniser le select h_notaire_ref après que les options sont rendues.
    // En Angular 5, le select avec [ngValue] ne resynchronise pas l'option sélectionnée
    // lorsque les options (datasNotaire) sont ajoutées APRÈS que la valeur du FormControl
    // a été définie via patchValue. On force un setValue dans un setTimeout pour que
    // le rendu des <option> soit effectué avant la re-sélection.
    if (this.datasNotaire && this.datasNotaire.length > 0) {
      setTimeout(() => {
        const currentRef = this.form3Data.at(0).get('h_notaire_ref').value;
        if (currentRef !== null && currentRef !== '') {
          this.form3Data.at(0).get('h_notaire_ref').setValue(currentRef, { emitEvent: false });
        }
      });
    }

    // Marquer les champs restaurés comme dirty pour éviter les faux positifs de validation
    this.markFilledControlsDirty(this.form1Data.at(0));
    this.markFilledControlsDirty(this.form2Data.at(0));
    this.markFilledControlsDirty(this.form3Data.at(0));
  }

  /**
   * Vérifie si le pays sélectionné est la France.
   * Utilisé dans le template pour conditionner la validation du code postal.
   */
  isFrance(item: any): boolean {
    return item.get('h_adresse__country').value === 'FR';
  }

  /**
   * Abonne le champ code postal aux changements de pays :
   * en France → pattern 5 chiffres, à l'étranger → pas de contrainte de format.
   */
  private setupCpLogic(group: FormGroup, countryField: string, cpField: string): void {
    group.get(countryField).valueChanges.subscribe(country => {
      const cpControl = group.get(cpField);
      if (country === 'FR') {
        cpControl.setValidators([Validators.required, Validators.pattern(/^\d{5}$/)]);
      } else {
        cpControl.setValidators([Validators.required]);
      }
      cpControl.updateValueAndValidity();
    });
  }

  /**
   * Marque comme dirty tous les contrôles du groupe ayant une valeur non vide.
   * Nécessaire après patchValue pour que checkFieldValidity n'affiche pas
   * d'erreur sur les champs restaurés depuis le localStorage.
   */
  private markFilledControlsDirty(group: any): void {
    if (!group || !group.controls) { return; }
    Object.keys(group.controls).forEach(key => {
      const val = group.controls[key].value;
      if (val !== null && val !== '' && val !== undefined) {
        group.controls[key].markAsDirty();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-h/app-form-h.component.ts